import { ORIENTATION_CHAPTER_NUMBER } from './const';

export const getIsOrientationChapter = (chapter: number) => {
    return chapter === ORIENTATION_CHAPTER_NUMBER;
};
